// src/components/Testimonial/Testimonial.jsx
import React from 'react';
import Slider from 'react-slick';
import FeedbackCard from './FeedbackCard';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import "../Testimonial/Testimonial.css";

const Testimonial = () => {
  const testimonials = [
    {
      quote: "Spiderlegs Productionsin äänentoistopalvelut tekivät hääjuhlastamme täydellisen! Stressitön ilta kun ei tarvinnut miettiä äänentoistoa ollenkaan, kaikki hoitui mallikkaasti.",
      author: "Mira",
      position: "Morsian",
      avatar: "https://randomuser.me/api/portraits/women/41.jpg",
    },
    {
      quote: "Yrityksemme juhlat sujuivat moitteettomasti. Vuokrausprosessi oli helppo ja kuljetuspalvelu iso PLUSSA!",
      author: "Marcus F.",
      position: "Toimitusjohtaja",
      avatar: "https://randomuser.me/api/portraits/men/57.jpg",
    },
    {
      quote: "Teemabileidemme pelastus! bilekaiutin ja langattomat mikit pelastivat karaoke-illan. Nopealla toimituksella, suosittelen lämpimästi!",
      author: "Sanna T.",
      position: "Bilejärkkäri",
      avatar: "https://randomuser.me/api/portraits/women/38.jpg",
    },
    {
      quote: "Juhliimme varattu trubaduuri sairastui, täältä saimme korvaajan vielä samalle illalle! Ihan mahtavaa!",
      author: "Janne L.",
      position: "Järjestäjä",
      avatar: "https://randomuser.me/api/portraits/men/15.jpg",
    },
    {
      quote: "Pikkujoulujen tunnelma oli huipussaan, kiitos Spiderlegs productionsin äänentoiston ja valoshown! Voin suositella kaikille yritystapahtumiin.",
      author: "Heidi M.",
      position: "HR-päällikkö",
      avatar: "https://randomuser.me/api/portraits/women/13.jpg",
    },
    {
      quote: "Kärrynvuokraus sujui kuin tanssi, siisti ja iso kärry. Suosittelut!",
      author: "Timo K.",
      position: "Muuttaja",
      avatar: "https://randomuser.me/api/portraits/men/3.jpg",
    },
    {
      quote: "Olipas helppo saada tarjous bändiltä häihimme, mahtava palvelu!",
      author: "Laura N.",
      position: "Morsian",
      avatar: "https://randomuser.me/api/portraits/women/52.jpg",
    },
  ];
  

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 4, // Näyttää kaksi testiota samanaikaisesti
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024, // Näyttää yhden testion pienemmillä näytöillä
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 768, // Näyttää yhden testion pienemmillä näytöillä
        settings: {
          slidesToShow: 1,
        }
      }
    ],
    fade: false, // Ei sulavaa siirtymää, koska näytetään useita
    cssEase: "linear",
  };

  return (
    <section className="container min-h-[620px] flex dark:bg-violet bg-primary dark:bg-opacity-75 bg-opacity-75 rounded-3xl pb-10 p-5 mb-20">
      <div className="container mx-auto px-4">
        {/* Otsikko ja Kuvaus */}
        <div className="mb-8">
          <h2 className="font-customFont2 dark:text-shadow-xxl text-left text-darkest dark:text-primary text-4xl sm:text-6xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-6xl font-bold leading-tight">
            Asiakaspalautteet
          </h2>
          <p className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light">
            Lue mitä asiakkaamme sanovat palveluistamme ja miksi Spiderlegs productions on heidän valintansa äänentoiston-ja esitystekniikan vuokrauksessa.
          </p>
        </div>

        {/* Karuselli */}
        <Slider {...settings}>
          {testimonials.map((testimonial, index) => (
            <div key={index} className="p-4 mb-20">
              <FeedbackCard
                quote={testimonial.quote}
                author={testimonial.author}
                position={testimonial.position}
                avatar={testimonial.avatar}
              />
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Testimonial;
